import Model from 'flarum/common/Model';

/**
 * A support department: a named group of staff used to route tickets.
 *
 * Categories link to a department; tickets opened in those categories are
 * assigned to and notified about department members first.
 */
export default class SupportDepartment extends Model {
  name = Model.attribute('name');
  slug = Model.attribute('slug');
  description = Model.attribute('description');
  /** Existing user ids, only sent to administrators. */
  userIds = Model.attribute('userIds');
  isActive = Model.attribute('isActive');
  memberCount = Model.attribute('memberCount');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  updatedAt = Model.attribute('updatedAt', Model.transformDate);
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/SupportDepartment', SupportDepartment);